import { render, staticRenderFns } from "./FinanceSettlements.vue?vue&type=template&id=4acda4ac"
import script from "./FinanceSettlements.vue?vue&type=script&lang=js"
export * from "./FinanceSettlements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports